import { USER_ROLES } from "../constant/roles";

export const PROTECTED_SYSTEM_ROLES = [
	USER_ROLES.SUPER_ADMIN,
	USER_ROLES.ADMIN,
	USER_ROLES.EMPLOYEE,
	USER_ROLES.API_USER,
];

export const isSystemRole = (role) => {
	const name = typeof role === "string" ? role : role?.name;
	return PROTECTED_SYSTEM_ROLES.includes(name);
};

export default isSystemRole;
